import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'error-pages.js-error-page.header',
		defaultMessage: 'Something went wrong on our end',
		description: 'Header that tells user there is an issue',
	},
	description: {
		id: 'error-pages.js-error-page.description',
		defaultMessage:
			'Try refreshing or navigating to another page. If you still see this message, our service might be disrupted.',
		description: 'Description describing issue to user.',
	},
	descriptionWithError: {
		id: 'error-pages.js-error-page.description-with-error',
		defaultMessage:
			'If this keeps happening, share this information with your admin, who should <link>contact support</link>.',
		description: 'Description providing instructions to user.',
	},
	linkText: {
		id: 'error-pages.js-error-page.link-text',
		defaultMessage: 'Check our status page for updates.',
		description: 'Link text that takes user to atlassian status page',
	},
	reloadPageButton: {
		id: 'error-pages.js-error-page.reload-page-button',
		defaultMessage: 'Refresh',
		description: 'Button that allows user to refresh page',
	},
});
